<div class="flex h-full w-full kc-chat-container">
  <kc-loader [loading]="loading"></kc-loader>

  <!-- Main Chat Container -->
  <div class="chat-container flex-1 transition-all duration-300"
       [ngClass]="{'w-full': !isMediaPanelOpen, 'w-4/5': isMediaPanelOpen}">

    <!-- Header -->
    <div class="chat-header flex bg-white kc-br-tp border-round items-center justify-between w-full gap-2 p-4 border-b border-surface">
      <div class="flex items-center gap-2">
        <app-conversation-initials
            [contact]="conversation.contact"
            [conversationAvatarId]="conversation.avatarId"
            [rounded]="true"
          >
          </app-conversation-initials>
        <div class="flex flex-col">
          <div class="text-color font-medium leading-6">
            {{ conversation.contact | contactDisplay: conversation.fromNumber }}
          </div>
          <div class="text-sm text-muted-color leading-5">
            @if (conversation.status === ConversationStatus.ASSIGNED_PENDING){
              <div class="conversation-status-pulse conversation-status-pulse--orange">
                <div class="dot"></div>
                <div class="outline"></div>
              </div>
              <span class="text-sm text-muted-color">Assegnazione Pendente</span>
            } @else if (conversation.status === ConversationStatus.TO_ASSIGN){
              <div class="conversation-status-pulse conversation-status-pulse--blue">
                <div class="dot"></div>
                <div class="outline"></div>
              </div>
              <span class="text-sm text-muted-color">Da Assegnare</span>
            } @else if (conversation.status === ConversationStatus.OPEN && conversation!.notificationCount! > 0){
              <div class="conversation-status-pulse conversation-status-pulse--blue">
                <div class="dot"></div>
                <div class="outline"></div>
              </div>
              <span class="text-sm text-muted-color">Da Leggere</span>
            } @else if (conversation.status === ConversationStatus.CLOSED){
              <div class="conversation-status-pulse conversation-status-pulse--red">
                <div class="dot"></div>
                <div class="outline"></div>
              </div>
              <span class="text-sm text-muted-color">Conversazione Chiusa</span>
            } @else {
              <div class="conversation-status-pulse conversation-status-pulse--green">
                <div class="dot"></div>
                <div class="outline"></div>
              </div>
              <span class="text-sm text-muted-color">Conversazione Aperta</span>
            }
          </div>
        </div>
        <div class="ms-5">
          @if (conversation.isWindowExpired){
            <p-message severity="error" size="small">Sessione Scaduta</p-message>
          } @else {
            <p-message severity="success" size="small">Sessione Attiva</p-message>
          }
        </div>

      </div>

      <div class="flex items-center gap-1">
        <div
          [ngClass]="'priority-' + conversation!.priority!.toLowerCase()"
        >
          <i [class]="getPriorityIcon(conversation!.priority!)"></i>
          {{ getPriorityLabel(conversation!.priority!) }}
        </div>
        @if(!isReadOnly){
          @if (conversation.status === ConversationStatus.OPEN){
            <p-button icon="fa-brands fa-meta" pTooltip="Rinnova sessione" tooltipPosition="bottom" text (click)="sendTemplateMessage()" [disabled]="!conversation.isWindowExpired"/>
          }
          @if (tenantSettings?.features?.revokeConversation?.enabled && (conversation.status === ConversationStatus.OPEN || conversation.status === ConversationStatus.ASSIGNED_PENDING)){
            <p-button icon="fa-light fa-arrow-rotate-left" pTooltip="Revoca" tooltipPosition="bottom" text  (onClick)="onRevokeConversation()" [disabled]="isReadOnly"/>
          }
          @if (conversation.status === ConversationStatus.CLOSED && !isReadOnly && closedByMe){
            <p-button icon="fa-light fa-lock-open" pTooltip="Riapri" tooltipPosition="bottom" text (onClick)="onReopenConversation()"/>
          }
          <div class="notes-btn-wrapper">
            <p-button icon="fa-light fa-note-sticky" pTooltip="Note" tooltipPosition="bottom" text (onClick)="openNotesPopover($event)"/>
            @if (conversation.notes) {
              <span class="notes-dot"></span>
            }
          </div>
          <p-button icon="fa-light fa-paperclip" pTooltip="Allegati" tooltipPosition="bottom" [outlined]="activePanel === 'media'" text (onClick)="onToggleMediaPanel()"/>
          <p-button icon="fa-light fa-ban" pTooltip="Chiudi" tooltipPosition="bottom" text (onClick)="onCloseConversation()" [disabled]="(conversation.isReadOnly || isReadOnly || conversation.status === ConversationStatus.CLOSED)" />
        }
      </div>

    </div>



    <!-- Scrollable Messages -->
    <div class="chat-messages flex flex-col gap-4"
         #messagesContainer
         (scroll)="onScroll()">

      <app-message-bubble
        *ngFor="let message of chatMessages"
        [message]="message"
        [contact]="conversation.contact"
        [disableActions]="conversation.isReadOnly || isReadOnly || conversation.status === ConversationStatus.CLOSED"
        (replyClicked)="handleReplySelection($event)"
        (replyContextClicked)="openContext($event)"
      >
      </app-message-bubble>

    </div>

    @if ((!conversation.isReadOnly && !isReadOnly) && conversation.status === ConversationStatus.OPEN) {
      <!-- Input -->
      <div class="chat-input-container"
           [class.chat-input-container--dragover]="isDragOver"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">

        <!-- Drag overlay -->
        <div class="chat-input__drag-overlay" *ngIf="isDragOver">
          <div class="chat-input__drag-zone" [class.chat-input__drag-zone--active]="dragSide === 'left'">
            <i class="fa-light fa-image-landscape"></i>
            <span>Media</span>
          </div>
          <div class="chat-input__drag-divider"></div>
          <div class="chat-input__drag-zone" [class.chat-input__drag-zone--active]="dragSide === 'right'">
            <i class="fa-light fa-folder"></i>
            <span>Preventivo</span>
          </div>
        </div>

        <!-- File preview chip -->
        <div class="chat-input__file-preview" *ngIf="selectedFile">
          <img *ngIf="previewFileUrl" [src]="previewFileUrl" class="chat-input__file-thumb"/>
          <i *ngIf="!previewFileUrl" class="fa-light fa-file chat-input__file-icon"></i>
          <span class="chat-input__file-name">{{ previewFileName }}</span>
          <button type="button" class="chat-input__file-quote-toggle" [class.active]="isQuote"
                  (click)="onToggleQuote()" pTooltip="Segna come preventivo" tooltipPosition="top">
            <i class="fa-light fa-folder"></i>
            <span>Preventivo</span>
          </button>
          <button type="button" class="chat-input__file-remove" (click)="onResetFileInput()">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Reply context -->
        @if(selectedReplyMessage){
          <app-chat-reply-context [replyMessage]="selectedReplyMessage" [conversation]="conversation" (clearReply)="onClearReply()"/>
        }

        <!-- Textarea -->
        <textarea pInputTextarea [(ngModel)]="newMessage"
                  class="w-full"
                  autoResize rows="1"
                  placeholder="Scrivi un messaggio…"
                  (keydown)="onKeyDown($event)"
                  (paste)="onPaste($event)">
        </textarea>

        <!-- Action bar -->
        <div class="chat-input__actions">
          <div class="chat-input__tools">
            <p-button icon="fa-light fa-message-quote" text (click)="onOpenTemplates()" pTooltip="Template" tooltipPosition="top"/>
            <p-button icon="fa-light fa-paperclip" text (click)="onTriggerFileInput()" pTooltip="Allega file" tooltipPosition="top"/>
            <p-button icon="fa-light fa-microphone" text pTooltip="Vocale" tooltipPosition="top" [disabled]="true"/>
          </div>
          <span class="chat-send-btn">
            <p-button icon="fa-light fa-paper-plane-top" (click)="onSendMessage()"/>
          </span>
          <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept="image/*,video/*,audio/*,application/*"/>
        </div>
      </div>
    }

    @if (conversation.status === ConversationStatus.CLOSED) {
      <div class="flex justify-center pb-5 px-10 z-10">
        <div class="inline-flex items-center gap-3 px-4 py-3 rounded-xl text-sm" style="background:#fff0f0;border:1px solid #ffcece;color:#e43f3f">
          <i class="fa-light fa-lock-keyhole shrink-0"></i>
          <span>Conversazione chiusa. I futuri messaggi provenienti da questo numero saranno automaticamente assegnati a una nuova conversazione.</span>
        </div>
      </div>
    }
  </div>

  <!-- Notes overlay -->
  @if (notesOpen) {
    <div class="notes-overlay" (click)="closeNotes()">
      <div class="notes-card" (click)="$event.stopPropagation()">
        <div class="notes-header">
          <div>
            <div class="notes-title">
              <i class="fa-light fa-note-sticky"></i>
              Note condivise
            </div>
            <div class="notes-subtitle">Visibili solo agli operatori · non inviate al contatto</div>
          </div>
          <span class="notes-save-status">
            @if (notesSaveStatus === 'saving') {
              <i class="pi pi-spin pi-spinner"></i> Salvataggio…
            } @else if (notesSaveStatus === 'saved') {
              <i class="pi pi-check"></i> Salvato
            }
          </span>
          <p-button icon="pi pi-times" text rounded size="small" severity="secondary" (onClick)="closeNotes()"/>
        </div>
        <div class="notes-body">
          <textarea
            [(ngModel)]="notesText"
            (ngModelChange)="onNotesInput($event)"
            class="notes-textarea"
            placeholder="Scrivi una nota condivisa…"
          ></textarea>
        </div>
      </div>
    </div>
  }

  <!-- Side Panel -->
  <div class="side-panel transition-all duration-300 overflow-hidden border-l border-surface"
       [ngClass]="{'w-0 opacity-0': !activePanel,'w-1/5 min-w-80 opacity-100': activePanel}">
    <ng-container [ngSwitch]="activePanel">
      <app-chat-side-panel-media *ngSwitchCase="'media'" [conversation]="conversation"/>
    </ng-container>
  </div>
</div>


<!-- Dialog Template -->
<p-dialog header="Scegli un Template" [modal]="true" [(visible)]="templateDialogVisible" [style]="{ width: '38rem' }" [draggable]="false">
  <div class="mb-4">
    <p-iconField iconPosition="left" class="w-full">
      <p-inputIcon class="fa-light fa-magnifying-glass"/>
      <input type="text" pInputText placeholder="Cerca template…" [(ngModel)]="searchText" (input)="onFilterTemplates()" class="w-full"/>
    </p-iconField>
  </div>

  <div class="template-list">
    @if (filteredTemplates.length === 0) {
      <div class="flex flex-col items-center justify-center py-10 gap-2 text-muted-color">
        <i class="fa-light fa-file-slash text-3xl opacity-40"></i>
        <span class="text-sm">Nessun template trovato</span>
      </div>
    }
    @for (template of filteredTemplates; track template.id) {
      <div class="template-item" [class.template-item--selected]="selectedTemplate?.id === template.id" (click)="onSelectTemplate(template)">
        <i class="fa-light fa-message-quote template-item__icon"></i>
        <span class="template-item__text">{{ template.text }}</span>
        <i class="fa-light fa-arrow-right template-item__arrow"></i>
      </div>
    }
  </div>
</p-dialog>

  <app-chat-history-drawer
    [conversationId]="drawerConversationId"
    [anchorMessageId]="drawerCenterMessageId"
    [(visible)]="drawerVisible"
  />
